import { getHomePageUrl, goToUrl } from '../../utils/aem-utils';
import { isInjectedHPInView } from '../../utils/injected-hp-utils';
import { landToElement } from '../../utils/land-to-element';
import { getLoginUrl } from '../../utils/build-urls';
import { isMobile } from '../../utils/device-utils';
import { setStatusOnLocalStorage } from '../../utils/local-storage';
import { RESPONSIVE_OFFSETS } from '../../utils/constants';

/**
 * Land on the widget depending on several circumstances
 * @param {Boolean} isUserLogged
 * @param {String} widgetId
 * @param {String} tabId
 * @param {object} bannerBottom {key, name, expirationDays} --> if not provided the click comes from the slim banner on HP
 * @returns {Function}
 */
export const getHandleSlimBannerPersonalizationClick =
  ({ isUserLogged, widgetId, widgetTab, bannerBottom }) =>
  (event) => {
    const homePageUrl = getHomePageUrl();
    const loginUrl = getLoginUrl(homePageUrl);
    const cannotLandInCurrentPage = (isMobile() && isInjectedHPInView()) || Boolean(bannerBottom);

    if (bannerBottom) {
      setStatusOnLocalStorage({
        key: bannerBottom.key,
        name: bannerBottom.name,
        expirationDays: bannerBottom.expirationDays,
      });
    }

    // Land on the widget in Home Page
    if (isUserLogged && cannotLandInCurrentPage) {
      event.preventDefault();
      landToElement.set({ elementId: widgetId, tabId: widgetTab });
      goToUrl(homePageUrl);
      return;
    }

    // Land on the widget on the current page
    if (isUserLogged) {
      event.preventDefault();
      const responsiveOffset = RESPONSIVE_OFFSETS.default;
      landToElement.land({ elementId: widgetId, tabId: widgetTab, responsiveOffset });
    }

    // Log-in then land on the widget in Home Page
    if (!isUserLogged) {
      event.preventDefault();
      landToElement.set({ elementId: widgetId, tabId: widgetTab });
      goToUrl(loginUrl);
    }
  };
